import api from "../services/api";

const path = "usuario";

export const userAuthentication = async ({ email, password }) => {
  return await api.post(`${path}/autenticar`, {
    Email: email,
    Password: password,
  });
};

export const userFirstAccess = async ({ code, email, password }) => {
  return await api.post(`${path}/primeiroAcesso`, {
    ConfirmationCode: code,
    Email: email,
    Password: password,
  });
};

export const userCodeRecover = async ({ email }) => {
  return await api.post(`${path}/enviarCodigo`, {
    email,
  });
};

export const userPasswordChange = async ({ email, password, codeRec }) => {
  return await api.put(`${path}/senha`, {
    Email: email,
    CodeRec: codeRec,
    Password: password,
  });
};

export const getUsers = async () => {
  return await api.get(`${path}/todos`);
};

export const findUser = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editUser = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createUser = async ({ body }) => {
  return await api.post(`${path}`, body);
};
